import type {
  OilPhasePVTFluidPropertyParametersBo,
  UnderSaturatedOilViscosityParameters
} from "../../d";
import { oilPhaseVolumeFactorBoCalculator } from "@/libs/calculations/oilPhase/oilPhaseVolumeFactor/kartoatmodjoSchmidt/oilPhaseVolumeFactorBoCalculator";

export function underSaturatedOilViscosityCalculator(
  params: UnderSaturatedOilViscosityParameters
): {
  undersaturatedOilViscosity: number;
  y: number;
  f: number;
  oilViscosityAtPb: number;
  solutionGasatPbRsb_km: number;
} {
  const { inSituPressurePSIA, bubblePointPressurePSIA, deadOilViscosity } =
    params;

  // WE ALWAYS WANT kartoatmodjoSchmidt FOR solutionGasPbRsb - this comes from the oilPhaseVolumeFactorBo calculation
  // Q126
  // const solutionGasatPbRsb_km = oilPhaseVolumeFactorBoCalculator(
  //   params as OilPhasePVTFluidPropertyParameters
  // ).solutionGasPbRsb;
  const kmbo = oilPhaseVolumeFactorBoCalculator({
    ...params,
    bubblePointPressurePSIA
  } as unknown as OilPhasePVTFluidPropertyParametersBo);
  const solutionGasatPbRsb_km = kmbo.solutionGasPbRsb;

  // Q128: =10**(-0.0008*Q126)
  const y = 10 ** (-0.0008 * solutionGasatPbRsb_km);

  // Q130: =(0.2001+0.8428*10**(-0.000845*Q126))*Q17**(0.43+0.5165*Q128)
  const f =
    (0.2001 + 0.8428 * 10 ** (-0.000845 * solutionGasatPbRsb_km)) *
    deadOilViscosity ** (0.43 + 0.5165 * y);

  // Q132: =-0.06821+0.9824*Q130+0.0004034*Q130**2
  const oilViscosityAtPb = -0.06821 + 0.9824 * f + 0.0004034 * f ** 2;

  // Q134: =1.00081*Q132+0.001127*(D3-J18)*(-0.006517*Q132**1.8148+0.038*Q132**1.59)
  const undersaturatedOilViscosity =
    1.00081 * oilViscosityAtPb +
    0.001127 *
      (inSituPressurePSIA - bubblePointPressurePSIA) *
      (-0.006517 * oilViscosityAtPb ** 1.8148 +
        0.038 * oilViscosityAtPb ** 1.59);
  return {
    undersaturatedOilViscosity,
    y,
    f,
    oilViscosityAtPb,
    solutionGasatPbRsb_km
  };
}
